import { useCallback } from 'react';
import { sanitizeReturnUrlAndRedirect } from '@/ui-kit/utils/sanitizeUrl';
import { Nullable } from '@/ui-kit/types';
import { useLocation } from 'react-router-dom';

export const useRouterStateReturnUrl = () => {
    const { state } = useLocation() as { state: Nullable<{ returnUrl?: string }> };
    const value = state?.returnUrl;
    const doRedirect = useCallback(() => {
        value && sanitizeReturnUrlAndRedirect(value);
    }, [value]);
    return [value, doRedirect] as const;
};
